import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-pwa-studio/commerce-pwa-studio/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Functions`}</p>
    <dl>
      <dt><a href="#useGiftCards">useGiftCards(props)</a> ⇒ <inlineCode><a href="#GiftCardsTalonProps">GiftCardsTalonProps</a></inlineCode></dt>
      <dd>
        <p>{`Handles the logic for a component that renders a list of gift cards.
It performs effects and returns the prop data necessary for rendering
the component.`}</p>
        <p>{`This talon performs the following effects:`}</p>
        <ul>
          <li parentName="ul">{`Fetch the currently applied gift cards for a cart`}</li>
          <li parentName="ul">{`Manage the updating state of the cart while a gift card is being applied or removed`}</li>
        </ul>
      </dd>
      <dt><a href="#useGiftCard">useGiftCard(props)</a> ⇒ <inlineCode><a href="#GiftCardTalonProps">GiftCardTalonProps</a></inlineCode></dt>
      <dd>
        <p>{`Provide logic for a single gift card component.`}</p>
      </dd>
    </dl>
    <p>{`Typedefs`}</p>
    <dl>
      <dt><a href="#GiftCardsMutations">GiftCardsMutations</a> : <inlineCode>Object</inlineCode></dt>
      <dd>
        <p>{`GraphQL mutations for Gift Cards.`}</p>
      </dd>
      <dt><a href="#GiftCardsQueries">GiftCardsQueries</a> : <inlineCode>Object</inlineCode></dt>
      <dd>
        <p>{`GraphQL queries for Gift Cards.`}</p>
      </dd>
      <dt><a href="#GiftCardsTalonProps">GiftCardsTalonProps</a> : <inlineCode>Object</inlineCode></dt>
      <dd>
        <p>{`Props data to use when rendering a list of gift cards.`}</p>
      </dd>
      <dt><a href="#GiftCardTalonProps">GiftCardTalonProps</a> : <inlineCode>Object</inlineCode></dt>
      <dd>
        <p>{`Props data to use when rendering a single gift card component.`}</p>
      </dd>
    </dl>
    <p>{`Handles the logic for a component that renders a list of gift cards.
It performs effects and returns the prop data necessary for rendering
the component.`}</p>
    <p>{`This talon performs the following effects:`}</p>
    <ul>
      <li parentName="ul">{`Fetch the currently applied gift cards for a cart`}</li>
      <li parentName="ul">{`Manage the updating state of the cart while a gift card is being applied or removed`}</li>
    </ul>
    <p><strong parentName="p">{`Returns:`}</strong>{`
`}<strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`props`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`props.setIsCartUpdating`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Callback function for setting the update state for the cart.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`props.mutations`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#GiftCardsMutations"
            }}><inlineCode parentName="a">{`GiftCardsMutations`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`GraphQL mutations for Gift Cards`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`props.queries`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#GiftCardsQueries"
            }}><inlineCode parentName="a">{`GiftCardsQueries`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`GraphQL queries for Gift Cards`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{` `}<em parentName="p">{`(Importing into your project)`}</em>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { useGiftCards } from '@magento/peregrine/lib/talons/CartPage/GiftCards'
`}</code></pre>
    <p>{`Provide logic for a single gift card component.`}</p>
    <p><strong parentName="p">{`Returns:`}</strong>{`
`}<strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`props`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`props.code`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`String`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Gift card's code`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`props.removeGiftCard`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A function that removes a gift card when provided a code`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{` `}<em parentName="p">{`(Importing into your project)`}</em>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { useGiftCard } from '@magento/peregrine/lib/talons/CartPage/GiftCards/useGiftCard';
`}</code></pre>
    <p>{`GraphQL mutations for Gift Cards.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://github.com/magento/pwa-studio/blob/develop/packages/peregrine/lib/talons/CartPage/GiftCards/giftCardQueries.gql.ee.js"
      }}><inlineCode parentName="a">{`giftCardQueries.ee.js`}</inlineCode></a>{`
for queries used in Venia`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Properties`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`applyGiftCardMutation`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`GraphQLAST`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The mutation used to apply a gift card to the cart.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`removeGiftCardMutation`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`GraphQLAST`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The mutation used to remove a gift card from the cart.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`GraphQL queries for Gift Cards.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://github.com/magento/pwa-studio/blob/develop/packages/peregrine/lib/talons/CartPage/GiftCards/giftCardQueries.gql.ee.js"
      }}><inlineCode parentName="a">{`giftCardQueries.ee.js`}</inlineCode></a>{`
for queries used in Venia`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Properties`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`getAppliedGiftCardsQuery`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`GraphQLAST`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The query used to get the gift cards currently applied to the cart.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`getGiftCardBalanceQuery`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`GraphQLAST`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The query used to get the gift cards currently applied to the cart.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Props data to use when rendering a list of gift cards.`}</p>
    <p><strong parentName="p">{`Properties`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`applyGiftCard`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A callback to apply a gift card to the cart.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`checkBalanceData`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The giftCardAccount object of the most recent successful check balance GraphQL query.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`checkGiftCardBalance`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A callback to check the balance of a gift card.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`errorLoadingGiftCards`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Whether there was an error loading the cart's gift cards.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`errorApplyingCard`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Whether there was an error applying the gift card.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`errorCheckingBalance`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Whether there was an error checking the balance of the gift card.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`errorRemovingCard`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Whether there was an error removing the gift card.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`giftCardsData`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Array`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The applied_gift_cards object of the cart query.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`isLoadingGiftCards`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Whether the cart's gift card data is loading.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`isApplyingCard`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Whether the apply gift card operation is in progress.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`isCheckingBalance`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Whether the check gift card balance operation is in progress.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`isRemovingCard`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Whether the remove gift card operation is in progress.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`removeGiftCard`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A callback to remove a gift card from the cart.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`shouldDisplayCardBalance`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Whether to display the gift card balance to the user`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`shouldDisplayCardError`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Whether to display an error message under the card input field.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Props data to use when rendering a single gift card component.`}</p>
    <p><strong parentName="p">{`Properties`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`removeGiftCardWithCode`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Function for removing a gift card associated with the code passed into this talon.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Source Code`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://github.com/magento/pwa-studio/blob/develop/packages/peregrine/lib/talons/CartPage/GiftCards/useGiftCards.js"
      }}>{`pwa-studio/packages/peregrine/lib/talons/CartPage/GiftCards/useGiftCards.js`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      